"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var FooterLegacy_1 = require("../_FooterLegacy/FooterLegacy");

var WrapperHelper_1 = require("../_Portal/WrapperHelper");

var FooterWrapper =
/** @class */
function (_super) {
  __extends(FooterWrapper, _super);

  function FooterWrapper(props) {
    var _this = _super.call(this, props) || this;

    var data = props.data || WrapperHelper_1.WrapperHelper.getData();
    _this.state = {
      data: {
        applicationData: __assign(__assign({}, data.applicationData), props.dataOverride.applicationData),
        frameworkData: __assign(__assign({}, data.frameworkData), props.dataOverride.frameworkData),
        navigationData: __assign(__assign({}, data.navigationData), props.dataOverride.navigationData),
        resourceBundleData: __assign(__assign({}, data.resourceBundleData), props.dataOverride.resourceBundleData),
        contentIncludesData: __assign(__assign({}, data.contentIncludesData), props.dataOverride.contentIncludesData)
      }
    };
    return _this;
  }

  FooterWrapper.prototype.componentWillReceiveProps = function (nextProps) {
    var data = nextProps.data || WrapperHelper_1.WrapperHelper.getData();
    this.setState({
      data: {
        applicationData: __assign(__assign({}, data.applicationData), nextProps.dataOverride.applicationData),
        frameworkData: __assign(__assign({}, data.frameworkData), nextProps.dataOverride.frameworkData),
        navigationData: __assign(__assign({}, data.navigationData), nextProps.dataOverride.navigationData),
        resourceBundleData: __assign(__assign({}, data.resourceBundleData), nextProps.dataOverride.resourceBundleData),
        contentIncludesData: __assign(__assign({}, data.contentIncludesData), nextProps.dataOverride.contentIncludesData)
      }
    });
  };

  FooterWrapper.prototype.render = function () {
    var data = this.state.data;
    var is10 = this.props.is10;

    if (!Object.keys(data.applicationData).length || !Object.keys(data.resourceBundleData).length || !Object.keys(data.navigationData).length || !Object.keys(data.contentIncludesData).length || !Object.keys(data.frameworkData).length) {
      // render nothing because data is missing
      return React.createElement("div", null);
    }

    var footerProps = {
      footerTree: [],
      applicationData: data.applicationData
    };
    var channel = window.ccb_cif && window.ccb_cif.channel;
    var isLogin = data.applicationData.loginStatus !== "FULL_LOGIN";
    var isFk = channel === "MSB_CB-WEB";
    footerProps.footerTree = data.navigationData.footerNavigation.map(function (tree) {
      return WrapperHelper_1.WrapperHelper.mapTree(tree, is10, isLogin, isFk);
    });

    if (is10) {
      return React.createElement(React.Fragment, null, React.createElement(FooterLegacy_1.FooterLegacy, __assign({}, footerProps)));
    }

    return React.createElement(React.Fragment, null);
  };

  FooterWrapper.defaultProps = {
    is10: true,
    dataOverride: {
      applicationData: {},
      frameworkData: {},
      navigationData: {},
      resourceBundleData: {}
    }
  };
  return FooterWrapper;
}(React.Component);

exports.FooterWrapper = FooterWrapper;